import { useEffect, useState } from "react";
import { getAllSites } from "../../../api/newsspecs/sites/SitesSpecsAPI";
import SiteLineChartPage from "./SiteLineChartPage";
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { PageHeader } from "../../../components/PageHeader";
import { useTranslation } from "react-i18next";

function SiteTopicDistributionWrapper() {
  const { t } = useTranslation(["common", "site"]);
  const [sites, setSites] = useState([]);
  useEffect(() => {
    getAllSites()
      .then((res) => setSites(res))
      .catch(() => {});
  }, []);

  const [chosenSite, setChosenSite] = useState("vnexpress");

  useEffect(() => {}, [chosenSite]);

  let sitesUnique = [...new Set(sites)];
  const buttons = sitesUnique.map(function (site) {
    return <MenuItem value={site["name"]}>{site["name"]}</MenuItem>;
  });

  return (
    <Grid container>
      <PageHeader
        text={t("site:site_basic_stats")}
        supplement={
          <FormControl
            fullWidth
            style={{
              height: "35px",
              marginBottom: "30px",
              width: "150px",
            }}
          >
            <Select
              value={chosenSite}
              label=""
              onChange={(event: SelectChangeEvent) => {
                setChosenSite(event.target.value as string);
              }}
              style={{ height: "35px" }}
            >
              {buttons}
            </Select>
          </FormControl>
        }
      />
      <Grid item xs={1.5}></Grid>
      <Grid
        item
        xs={9}
        style={{ fontSize: "1.5rem" }}
        className="grid-border white"
      >
        <SiteLineChartPage site={chosenSite} day={10} />
      </Grid>
      <Grid item xs={1.5}></Grid>
    </Grid>
  );
}

export default SiteTopicDistributionWrapper;
